import { getBannerCarousel } from "@NA/Services/GetBannerCarousel";
import { getVisualCarousal, visualCarousalParams, VisualFilterCarousal } from "@NA/Services/GetVisualCarousal";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<visualCarousalParams, VisualFilterCarousal>;

export const DispatchvisualFilters: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/LoadVisualFilters",
        result: props.parameter,
    });
};

export const LoadvisualFilters: HandlerType = async (props: any) => {
    props.apiResult = await getVisualCarousal(props.parameter);
};

export const DispatchCompleteLoadvisualFilters: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchCompleteVisualFilters",
        visualFilter: props.apiResult,
    });
};

export const chain = [DispatchvisualFilters, LoadvisualFilters, DispatchCompleteLoadvisualFilters];

const loadVisualFilters = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        pathUrl: "",
    },
    "loadVisualFilters",
);
export default loadVisualFilters;
